import React from 'react';
import moment from "moment";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {DateInput} from '@opuscapita/react-dates';

const Container = styled.div`
  & .force-block { display: block !important; width: 140px !important;}
  & .opuscapita_date-input__reset-btn, 
    .opuscapita_date-input__variants-btn { display: none; }
`;

const DatePicker = ({value, onChange, disabled, error}) => {
  return (
    <Container>
      <DateInput
        locale="en"
        className={error ? "has-error force-block" : "force-block"}
        disabled={disabled}
        variants={undefined}
        dateFormat="MM/dd/yyyy"
        placehold={null}
        onChange={date => onChange(date ? moment(date).format('YYYY-MM-DD') + 'T10:00:00Z': '')}
        value={value ? moment.utc(value).toDate() : null}
      />
    </Container>
  );
};

DatePicker.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  disabled: PropTypes.bool
};

export const BlankDatePicker = () => (
  <div className="opuscapita_date-input form-control force-block">
    <div className="opuscapita_date-input__input-container">
      <div className="opuscapita_date-input-field form-control" disabled>
        <input
          type="text"
          className="opuscapita_date-input-field__input"
          value=""
          placeholder=""
          disabled
          tabIndex="0"
        />
      </div>
    </div>
  </div>
);

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/forms/DatePicker.js